import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { FornecedorService } from '../../fornecedor/fornecedor.service';
import { EventoFornecedor } from '../../fornecedor/models/fornecedor';
import { ProdutoEventoFornecedor } from '../../produto/models/produto';
import { ProdutoService } from '../../produto/produto.service';
import { EventoService } from '../evento.service';
import { EventoProduto, EventoProdutoEvento } from '../models/evento';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-evento-detalhe-produto',
  templateUrl: './evento-detalhe-produto.component.html',
  styleUrls: ['./evento-detalhe-produto.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class EventoDetalheProdutoComponent implements OnInit, OnChanges {

  @Input() idEvento: number = 0;
  @Input() nomeFornecedor = '';

  public eventoProdutos: EventoProdutoEvento[] = [];
  public eventoProduto: EventoProduto = {};

  public produtos: ProdutoEventoFornecedor[] = [];  
  public produtosSelected: ProdutoEventoFornecedor[] = [];  
  public produto: ProdutoEventoFornecedor = {};

  public eventoFornecedores: EventoFornecedor[] = [];
  public eventoFornecedor: EventoFornecedor = {};
  
  public recivedMessage:any;
  public subscription: Subscription;
  public isDisableProduto: boolean = false;
  public isProdutoEstoque: boolean = false;
  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;

  
  constructor(public eventoService: EventoService,
              public produtoService: ProdutoService,
              public fornecedorService: FornecedorService,
              private messageService: MessageService,
              private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.getEventoProdutos(this.idEvento); 
    this.getProdutosEventoFornecedor();  
    this.getEventoFornecedores(this.idEvento);             
  }  

  ngOnChanges(changes: SimpleChanges) {
//    console.log(changes);
//    this.nomeFornecedor = changes.nomeFornecedor.currentValue;
  }



  getProdutosEventoFornecedor() {

    this.produtoService.getProdutosEventoFornecedor().subscribe(
      (res) => {
        if (res) {
          this.produtos = res;          
          this.produtos.forEach(element => {
            element.busca = element.cdInterno+' - '+element.nome
          });
        }
      },
      err => {
        console.log("EventoDetalheFornecedor - ProdutoEventoForncedor");
        console.log(err);
      }
    );
  }

  getEventoFornecedores(idEvento: number) {
    this.fornecedorService.getEventoFornecedores(idEvento).subscribe(
      (res) => {
        if (res) {
          this.eventoFornecedores = res;          
        }
      },
      err => {
        console.log("EventoDetalheProduto - EventoFornecedor");
        console.log(err);
      }
    );
  }

  getEventoFornecedor(idEventoFornecedor) {

    this.fornecedorService.getEventoFornecedor(idEventoFornecedor).subscribe(
      (res) => {
        if (res) {          
          this.eventoFornecedor = res;
        }
      },
      err => {
        console.log("EventoDetalheProduto - EventoFornecedor");
        console.log(err);
      }
    );
  }


  getEventoProdutos(idEvento: number) {

    this.eventoService.getEventoProdutos(idEvento).subscribe(
      (res) => {
        if (res) {
          this.eventoProdutos = res;          
        }
      },
      err => {
        console.log("EventoDetalheProduto - EventoProduto");
        console.log(err);
      }
    );
  }

  getSelectedProduto(idProduto: number) {    
    this.produto = this.produtos.find(x => x.idProduto === idProduto);        
  }

  SetEventoProduto(idProduto: number)
  {
    this.eventoProduto.idProdutoOriginal = this.produto.idProduto;    
  }

  getSelectedEventoFornecedor(idEventoFornecedor: number) {    
    this.eventoFornecedor = this.eventoFornecedores.find(x => x.idEventoFornecedor === idEventoFornecedor);    
  }

  getSelectedProdutoEventoFornecedor(idEventoFornecedor: number) {      
    if (idEventoFornecedor == 0){
      this.produtosSelected = this.produtos;      
    }
    else{
      this.produtosSelected = this.produtos.filter(x => x.idEventoFornecedor != idEventoFornecedor);      
    }
  }

  SetEventoFornecedor()
  {
    this.getSelectedEventoFornecedor(this.eventoFornecedor.idEventoFornecedor); 
    this.getSelectedProdutoEventoFornecedor(this.eventoFornecedor.idEventoFornecedor);
    this.eventoProduto.idEventoFornecedor = this.eventoFornecedor.idEventoFornecedor;    
  }

  
  addEventoProduto() {
    this.getSelectedProdutoEventoFornecedor(this.eventoFornecedor.idEventoFornecedor);
    this.getEventoFornecedores(this.idEvento);       
    this.eventoFornecedor = {};    
    this.eventoProduto = {};
    this.isDisableProduto = false;
    this.submitted = false;
    this.displayDialog = true;    
  }

  updEventoProduto(eventoProduto: EventoProduto) { 
    this.getSelectedProdutoEventoFornecedor(0);
    this.getEventoFornecedores(this.idEvento);        
    this.isDisableProduto = true;   
    this.eventoProduto = { ...eventoProduto };   
    this.getSelectedProduto(this.eventoProduto.idProdutoOriginal);   
    this.getSelectedEventoFornecedor(this.eventoProduto.idEventoFornecedor); 
    this.displayDialog = true;
  }

  addEventoProdutoEstoque(eventoProduto: EventoProduto) { 
    this.getSelectedProdutoEventoFornecedor(0);
    this.getEventoFornecedores(this.idEvento);        
    this.isDisableProduto = true;   
    this.eventoProduto = { ...eventoProduto };   
    this.eventoProduto.qtdeTotal = 0;
    this.eventoProduto.vlPrecoCustoNovo = this.eventoProduto.vlPrecoCusto;
    this.eventoProduto.flMedio = true;
    this.getSelectedProduto(this.eventoProduto.idProdutoOriginal);   
    this.getSelectedEventoFornecedor(this.eventoProduto.idEventoFornecedor); 
    this.displayDialog = true;
    this.isProdutoEstoque = true;
  }

  delEventoProduto(eventoProduto: EventoProduto) {
    this.confirmationService.confirm({
      message: 'Você tem certeza que deseja remover o produto selecionado?',
      header: 'Confirmação',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.eventoService
          .delEventoProduto(eventoProduto.idEventoProduto)
          .subscribe(
            () => {
              this.getEventoProdutos(this.idEvento); 
              this.getProdutosEventoFornecedor();       
              this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Produto removido com sucesso!', life: 3000 });
            },
            err => {
              console.log(err);
              this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Ocorreu um erro ao remover o produto. '+err, life: 10000 });
            }
          );                  
      }
    });
  }

  hideDialog() {
    this.displayDialog = false;
    this.submitted = false;
    this.isProdutoEstoque = false;
  }

  saveProduto() {
    this.submitted = true;
    if (this.eventoProduto.idEventoProduto) {            
      this.eventoService
        .updEventoProduto(this.eventoProduto)
        .subscribe(
          () => {            
            this.getEventoProdutos(this.idEvento); 
            this.getProdutosEventoFornecedor();       
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Produto atualizado com sucesso!', life: 3000 });
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err);
          }
        );
      
    } else {          
      this.eventoProduto.idEventoFornecedor = this.eventoFornecedor.idEventoFornecedor;
      this.eventoService
        .addEventoProduto(this.eventoProduto)
        .subscribe(
          () => {
            this.getEventoProdutos(this.idEvento); 
            this.getProdutosEventoFornecedor();       
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Produto cadastrado com sucesso!', life: 3000 });
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err)
          }
        );

      
    }

    this.eventoProdutos = [...this.eventoProdutos];
    this.displayDialog = false;
    this.eventoProduto = {};
  }

  saveEstoque() {

    if(this.eventoProduto.vlPrecoCustoNovo==0){
      this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Novo preço de Custo é obrigatório', life: 10000 });
      return
    }

    if(this.eventoProduto.qtdeEstoqueAdicional==0){
      this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Quantidade adicional é obrigatório', life: 10000 });
      return
    }

    this.submitted = true;
    if (this.eventoProduto.idEventoProduto) {            
      this.eventoService
        .updEventoProdutoEstoque(this.eventoProduto)
        .subscribe(
          () => {            
            this.getEventoProdutos(this.idEvento); 
            this.getProdutosEventoFornecedor();       
            this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Produto atualizado com sucesso!', life: 3000 });
          },
          err => {
            this.messageService.add({ severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações. Erro:'+err, life: 10000 });
            console.log(err);
          }
        );
      
    } 
    this.eventoProdutos = [...this.eventoProdutos];
    this.displayDialog = false;
    this.eventoProduto = {};
    this.isProdutoEstoque = false;
  }

  exportExcel(){
    this.eventoService.getEventoProdutos(this.idEvento).subscribe(
      (res) => {
        if (res) {
          this.eventoProdutos = res; 
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(this.eventoProdutos);
            const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
            const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
            this.saveAsExcelFile(excelBuffer, "produtos feira");  
          });       
        }
      },
      err => {
        console.log("EventoDetalheProduto - EventoProduto");
        console.log(err);
      }
    );
  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
}


}


function ChildComponent(ChildComponent: any) {
  throw new Error('Function not implemented.');
}

